import type { Step } from "react-joyride";

export const checklistFormTourSteps: Step[] = [
  {
    target: "body",
    content: "ຍິນດີຕ້ອນຮັບສູ່ຟອມສ້າງ Checklist! ທ່ານຈະໄດ້ຮຽນຮູ້ວິທີໃຊ້ງານຟອມນີ້ໃນບົດສອນສັ້ນໆນີ້.",
    placement: "center",
    disableBeacon: true,
  },
  {
    target: '[data-tourid="form-title"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຊື່ Checklist. ກະລຸນາໃສ່ຊື່ທີ່ຊັດເຈນແລະອະທິບາຍວ່າ Checklist ນີ້ໃຊ້ສຳລັບຫຍັງ. ຕົວຢ່າງ: 'ກວດສອບການເປີດຮ້ານ' ຫຼື 'ກວດສອບຄຸນນະພາບສິນຄ້າ'.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-description"]',
    content:
      "ນີ້ແມ່ນຊ່ອງຄຳອະທິບາຍ. ທ່ານສາມາດໃສ່ຄຳອະທິບາຍເພີ່ມເຕີມກ່ຽວກັບ Checklist ນີ້ (ບໍ່ບັງຄັບ). ຄຳອະທິບາຍຈະຊ່ວຍໃຫ້ຜູ້ໃຊ້ອື່ນເຂົ້າໃຈຈຸດປະສົງຂອງ Checklist ນີ້.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-type"]',
    content:
      "ນີ້ແມ່ນການເລືອກປະເພດ Checklist. ທ່ານຕ້ອງເລືອກປະເພດທີ່ເໝາະສົມກັບ Checklist ຂອງທ່ານ. ທ່ານສາມາດຈັດການປະເພດໄດ້ຈາກປຸ່ມການຕັ້ງຄ່າທາງຂວາ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-department"]',
    content:
      "ນີ້ແມ່ນການເລືອກພະແນກ. ຖ້າ Checklist ນີ້ເປັນສະເພາະກັບພະແນກໃດໜຶ່ງ, ທ່ານສາມາດເລືອກພະແນກນັ້ນໄດ້ (ບໍ່ບັງຄັບ). ຖ້າບໍ່ເລືອກ, Checklist ນີ້ຈະສາມາດໃຊ້ໄດ້ທຸກພະແນກ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-schedule-type"]',
    content:
      "ນີ້ແມ່ນການເລືອກຊ່ວງເວລາໃຊ້ງານ. ເລືອກວ່າ Checklist ນີ້ຄວນຖືກໃຊ້ເມື່ອໃດ: ທຸກມື້, ເວລາເປີດຮ້ານ, ເວລາປິດຮ້ານ, ຫຼືຕາມກຳນົດ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-status"]',
    content:
      "ນີ້ແມ່ນການເລືອກສະຖານະ. ເລືອກ 'ປັບປຸງ' ຖ້າຍັງບໍ່ພ້ອມໃຊ້ງານ, 'ໃຊ້ງານ' ຖ້າພ້ອມໃຊ້ງານແລ້ວ, ຫຼື 'ເລີກໃຊ້' ຖ້າບໍ່ຕ້ອງການໃຊ້ງານອີກຕໍ່ໄປ.",
    placement: "bottom",
  },
  {
    target: '[data-tourid="form-items"]',
    content:
      "ນີ້ແມ່ນພາກການຈັດການລາຍການງານ. ທ່ານສາມາດເພີ່ມລາຍການກວດສອບຕ່າງໆທີ່ຕ້ອງເຮັດ. ສຳລັບແຕ່ລະລາຍການ, ທ່ານສາມາດກຳນົດວ່າຈຳເປັນຕ້ອງເຮັດ ຫຼືອະນຸຍາດໃຫ້ເພີ່ມໝາຍເຫດ. ກົດປຸ່ມ 'ເພີ່ມລາຍການ' ເພື່ອເລີ່ມຕົ້ນ.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-settings"]',
    content:
      "ນີ້ແມ່ນການຕັ້ງຄ່າເພີ່ມເຕີມ. ທ່ານສາມາດກຳນົດວ່າ: ຕ້ອງຕິກໃຫ້ຄົບທຸກຂໍ້ກ່ອນຈົບ, ຕ້ອງຖ່າຍຮູບແນບ, ຫຼືຕ້ອງໃສ່ໝາຍເຫດຖ້າບໍ່ຕິກ. ການຕັ້ງຄ່າເຫຼົ່ານີ້ຈະຊ່ວຍໃຫ້ການກວດສອບມີຄຸນນະພາບແລະຄົບຖ້ວນຫຼາຍຂຶ້ນ.",
    placement: "top",
  },
  {
    target: '[data-tourid="form-submit"]',
    content:
      "ຫຼັງຈາກຕື່ມຂໍ້ມູນຄົບຖ້ວນແລ້ວ, ກົດປຸ່ມ 'ບັນທຶກ' ເພື່ອບັນທຶກ Checklist ຂອງທ່ານ. Checklist ທີ່ບັນທຶກແລ້ວຈະສາມາດໃຊ້ງານໄດ້ທັນທີ.",
    placement: "top",
  },
];
